<template>
  <div class="select">
     <!-- :right-icon="value != '' && !required ? 'close' : ''" -->
    <van-field
      class="border-bottom"
   
      v-model="value"
      :placeholder="placeholder"
     
    
      @click-right-icon="clear"
      readonly="readonly"
      @input="inputParant"
      @click-input="timevisible"
      :left-icon="lefticon"
      :required="required"
      :rules="rules"
      :disabled="disabled"
    ></van-field>
    <van-popup
      v-model="popupdateTimeVisible"
      position="bottom"
      round
      :overlay="true"
      get-container="body"
    >
      <van-datetime-picker
        v-model="pdate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
  </div>
</template>

<script>
import { Popup, Field, DatetimePicker } from 'vant';
import { getzshgDate } from './swDate';
Date.prototype.Format = function(fmt) {
  //author: meizz
  let o = {
    'M+': this.getMonth() + 1, //月份
    'd+': this.getDate(), //日
    'h+': this.getHours(), //小时
    'm+': this.getMinutes(), //分
    's+': this.getSeconds(), //秒
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  for (let k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
  return fmt;
};
function stringToDate(_date, _format, _delimiter) {
  for (let i = 0; i < _format.length; i++) {
    let cc = _format.charAt(i);
    if (cc.charCodeAt() == 45 || cc.charCodeAt() == 47) {
      _delimiter = cc;
      break;
    }
  }
  let formatLowerCase = _format.toLowerCase();
  let formatItems = formatLowerCase.split(_delimiter);
  let dateItems = _date.split(_delimiter);
  if (_delimiter) {
    let monthIndex = formatItems.indexOf('mm');
    let dayIndex = formatItems.indexOf('dd');
    let yearIndex = formatItems.indexOf('yyyy');
    let month = parseInt(dateItems[monthIndex]);
    month -= 1;
    let formatedDate = new Date(
      dateItems[yearIndex],
      month,
      dateItems[dayIndex]
    );
    return formatedDate;
  } else {
    let formatLowerCase = _format.toLowerCase();
    if (formatLowerCase == 'yyyymmdd' && _date.length > 7) {
      return new Date(
        _date.substr(0, 4) + '-' + _date.substr(4, 2) + '-' + _date.substr(6, 2)
      );
    } else {
      return new Date();
    }
  }
}
export default {
  name: 'swSelectDate',
  props: {
    'min-date': {
      type: Date,
      default: () => {
        return getzshgDate(-365 * 350);
      }
    },
    'max-date': {
      type: Date,
      default: () => {
        return getzshgDate(365 * 2220);
      }
    },
    name: {
      type: String
    },
    label: {
      type: String
    },
    lefticon: {
      type: String
    },
    value: {
      type: String
    },
    placeholder: {
      type: String
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    required: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    rules: {
      type: Array
    }
  },
  data: function() {
    return {
      pdate: new Date(),
      popupdateTimeVisible: false
    };
  },
  methods: {
    confirm: function confirm(date) {
      this.$emit('input', date.Format(this.format));
      this.popupdateTimeVisible = false;
      this.$emit('change');
    },
    clear: function() {
      this.$emit('input', '');
      this.popupdateTimeVisible = false;
      this.$emit('change');
    },
    cancel: function cancel() {
      this.popupdateTimeVisible = false;
    },
    timevisible: function timevisible() {
      this.popupdateTimeVisible = true;
    },
    inputParant: function inputParant(e) {
      this.$emit('input', e.target.value);
    }
  },
  mounted: function mounted() {
    if (this.value !== '') {
      this.pdate = stringToDate(this.value, this.format);
    } else {
      this.pdate = new Date();
    }
  },
  watch: {
    value: function value(_value) {
      if (_value != '') {
        this.pdate = stringToDate(_value, this.format);
      } else if (_value == '') {
        this.pdate = new Date();
      }
    },
    
  },
  components: {
    [Popup.name]: Popup,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker
  }
};
</script>
